import { Navigation } from "components/navigation"
import { useAppUI } from "providers/ui"

export const AppNavigation = () => {
  const { sideMenus, matchedPath } = useAppUI()
  return <Navigation value={matchedPath?.to} navigations={sideMenus} />
}
